// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3yU-G","name":"ConsentHeader_name__tYgeJ","birthday":"ConsentHeader_birthday__3j2oL","skeleton":"ConsentHeader_skeleton__qMj-i"};